const INVERSE_RELATIONSHIP_MAP = {
  mother: "child",
  mom: "child",
  mum: "child",
  father: "child",
  dad: "child",
  son: "parent",
  daughter: "parent",
  husband: "spouse",
  wife: "spouse",
  spouse: "spouse",
  brother: "sibling",
  sister: "sibling",
  sibling: "sibling",
  grandmother: "grandchild",
  grandma: "grandchild",
  grandfather: "grandchild",
  grandpa: "grandchild",
  grandson: "grandparent",
  granddaughter: "grandparent",
  aunt: "niece/nephew",
  uncle: "niece/nephew",
  niece: "aunt/uncle",
  nephew: "aunt/uncle",
  cousin: "cousin",
  friend: "friend",
  relative: "relative",
  guardian: "dependent",
  caregiver: "care recipient"
};

export function getElderFacingRelationship(relationship) {
  if (!relationship) {
    return "";
  }

  const normalizedRelationship = relationship.trim().toLowerCase();

  return INVERSE_RELATIONSHIP_MAP[normalizedRelationship] || normalizedRelationship;
}
